import React, { useEffect, useState } from 'react';
import SideDrawer from '../../../../common/_custom/SideDrawer/SideDrawer';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setShowManageUserDrawer } from '../../../../store/company/action';
import ManageUser from '../../../Investor/ManageUser/ManageUser';
import Button from '../../../../common/_custom/Button/Button';
import styles from './ManageUserDrawer.module.scss';
import AddUserModal from '../../../Investor/ManageUser/ManageUserTable/components/AddUserModal';
import { COLORS } from '../../../../utils/constants/colors';

type ManageUserDrawerProps = {
    onClose?: (shouldRefetch?: boolean) => void;
    selectedUsers?: any[];
    parentCategory?: string | null;
    isOrgDrawer?: boolean;
    selectedOrgName?: string;
    onUsersUpdate?: (updatedUsers: any[]) => void;
    /**
     * Org whose users are being managed. Callers on routes that carry the org in the
     * path (e.g. the company dashboard, /portfolio/:id) can omit it and fall through
     * to the `orgId` search param / route param. The Leads listing has neither, so it
     * passes the row's org explicitly.
     */
    organizationId?: string;
};

export const ManageUserDrawer = ({
    onClose,
    selectedUsers: initialSelectedUsers,
    parentCategory,
    isOrgDrawer = false,
    selectedOrgName,
    onUsersUpdate,
    organizationId: organizationIdProp,
}: ManageUserDrawerProps) => {
    const dispatch = useDispatch();
    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [showAddUserModal, setShowAddUserModal] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState(initialSelectedUsers || []);
    const [userAdded, setUserAdded] = useState(false);
    const organizationId = organizationIdProp ?? searchParams.get('orgId') ?? params.id;
    const currentRowUser = { organizationId };

    const handleClose = () => {
        if (onClose) {
            onClose(userAdded);
        } else {
            searchParams.delete('category');
            searchParams.delete('page');
            setSearchParams(searchParams);
            dispatch(setShowManageUserDrawer(false));
        }
    };

    useEffect(() => {
        if (initialSelectedUsers) {
            setSelectedUsers(initialSelectedUsers);
        }
    }, [initialSelectedUsers]);

    const handleUserAdded = (newUser: any) => {
        setSelectedUsers((prev) => [...(prev || []), newUser]);
        setUserAdded(true);
        searchParams.delete('orgId');
        setSearchParams(searchParams);
    };

    return (
        <>
            <SideDrawer
                onClose={handleClose}
                style={{
                    backgroundColor: COLORS.LIGHT_GREY_BG,
                    overflowY: 'auto',
                }}
                iconStyle={{ zIndex: 20 }}
                width={'70%'}
            >
                <div className={styles.DrawerContent}>
                    <ManageUser
                        isOrgDrawer={isOrgDrawer}
                        selectedUsers={selectedUsers}
                        parentCategory={parentCategory}
                        selectedOrgName={selectedOrgName}
                        onUsersUpdate={onUsersUpdate}
                    />
                    {isOrgDrawer && (
                        <div className={styles.DrawerFooter}>
                            <div className={styles.ButtonContainer}>
                                <Button text="Close" onClick={handleClose} variant="secondary" />
                                <Button text="Add User" onClick={() => setShowAddUserModal(true)} variant="purple" />
                            </div>
                        </div>
                    )}
                </div>
            </SideDrawer>
            {showAddUserModal && (
                <AddUserModal
                    showAddUserModal={showAddUserModal}
                    setShowAddUserModal={setShowAddUserModal}
                    currentRowUser={currentRowUser}
                    onClose={() => setShowAddUserModal(false)}
                    fetchRows={() => Promise.resolve()}
                    pageNo={1}
                    onUserAdded={handleUserAdded}
                    isOrgDrawer={isOrgDrawer}
                />
            )}
        </>
    );
};
